import React from 'react'
import { render } from 'react-dom'
import { browserHistory } from 'react-router'
import { syncHistoryWithStore } from 'react-router-redux'
import axios from 'axios';

import 'rc-pagination/assets/index.css';
import 'react-select/dist/react-select.css';
import 'rc-checkbox/assets/index.css';
import 'antd/dist/antd.css';

import { SERVER_URL } from './config/host';

import Root from './containers/Root'
import configureStore from './store/configureStore'
import { checkCookie, getCookie, deleteCookie } from './cookies/';
import { COOKIE_KEY, VERSION } from './config/session';

import '../public/css/simple-line-icons.css';
import '../public/css/font-awesome.css';
import '../public/scss/style.scss';

axios.defaults.withCredentials = true;
axios.interceptors.request.use((config) => {
  const { url } = config;
  if (/^\/api\//.test(url) && !checkCookie(COOKIE_KEY)) { // 含 /api/ 且 没有cookie
    // TODO 提示没有登录
    browserHistory.push('/pages/login'); // 跳转到登录页
  }
  return { ...config, url: `${SERVER_URL}${url}?version=${VERSION}`, headers: { token: getCookie(COOKIE_KEY) } };
});
axios.interceptors.response.use((response) => {
  if (!response.data.tokenValid) {
    deleteCookie(COOKIE_KEY);
    browserHistory.push('/pages/login'); // 跳转到登录页
  }
  return response;
}, (error) => {
  const { message } = error;
  if (message === 'Request failed with status code 401') {
    // TODO 提示没有登录
    browserHistory.push('/pages/login'); // 跳转到登录页
  }
  return error;
});

const store = configureStore()
const history = syncHistoryWithStore(browserHistory, store, {
  selectLocationState (state) {
    return state.get('routerReducer');
  }
})

render(
  <Root store={store} history={history} />,
  document.getElementById('root')
)



// WEBPACK FOOTER //
// ./index.js